function deepClone(x) {
  return JSON.parse(JSON.stringify(x));
}

export default deepClone;
